export const CUSTOMERS: string = 'customers';
export const VISITS: string = 'visits';
export const PROPERTIES: string = 'properties';
export const COMMUNITIES: string = 'communities';
export const AGENTS: string = 'agents';
